{
  "dropzones.clear_time": "Yalnız saati kaldır",
  "dropzones.clear_time_target": "Yalnız saati kaldırmak için bırak",
  "dropzones.defer_day": "Sonraki güne taşı",
  "dropzones.defer_day_target": "Sonraki güne taşımak için bırak",
  "dropzones.unschedule": "Tarihi kaldır",
  "dropzones.unschedule_target": "Tarihi kaldırmak için bırak",
  "dropzones.schedule_updated": "Planlanan zaman güncellendi",
  "dropzones.action_failed": "Görev güncellenemedi"
}
